import { styled } from "@mui/material/styles"

import Column from "../../../common/components/Column"

export default styled(Column)(({ theme }) => ({
  marginTop: theme.spacing(2),
  [theme.breakpoints.only("xs")]: {
    marginTop: theme.spacing(2),
  },
}))
